function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var noop = function noop() {};
var createSelectorFunction = function createSelectorFunction(name) {
  if (Array.isArray(name)) {
    name = name.join(',');
  }
  if (!name || typeof name !== 'string') {
    return noop;
  }
  return function (props) {
    var result = {};
    if (props && _typeof(props) === 'object') {
      result[name] = props;
    }
    return Object.entries(result);
  };
};
var createNthOfTypeSelectorFunction = function createNthOfTypeSelectorFunction(name) {
  if (Array.isArray(name)) {
    name = name.join(',');
  }
  if (!name || typeof name !== 'string') {
    return noop;
  }
  return function (props) {
    var result = {};
    if (props && _typeof(props) === 'object') {
      for (var _i = 0, _Object$entries = Object.entries(props); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        result["".concat(name, "(").concat(key, ")")] = value;
      }
    }
    return Object.entries(result);
  };
};

/**
 * Pseudo-classes
 * https://developer.mozilla.org/en-US/docs/Web/CSS/
 */
var pseudoClassSelector = {
  _active: createSelectorFunction(['&:active', '&[data-active]']),
  _checked: createSelectorFunction(['&:checked', '&[aria-checked=true]', '&[data-checked]']),
  _disabled: createSelectorFunction(['&:disabled', '&:disabled:focus', '&:disabled:hover', '&[aria-disabled=true]', '&[aria-disabled=true]:focus', '&[aria-disabled=true]:hover', '&[data-disabled]']),
  _empty: createSelectorFunction('&:empty'),
  _enabled: createSelectorFunction(['&:enabled', '&:enabled:focus', '&:enabled:hover']),
  _firstChild: createSelectorFunction('&:first-child'),
  _firstOfType: createSelectorFunction('&:first-of-type'),
  _fullscreen: createSelectorFunction('&:fullscreen'),
  _focus: createSelectorFunction(['&:focus', '&[data-focus]']),
  _focusActive: createSelectorFunction('&:focus:active'),
  _focusHover: createSelectorFunction('&:focus:hover'),
  _focusVisible: createSelectorFunction('&:focus-visible'),
  _focusWithin: createSelectorFunction('&:focus-within'),
  _hover: createSelectorFunction(['&:hover', '&[data-hover]']),
  _indeterminate: createSelectorFunction(['&:indeterminate']),
  _invalid: createSelectorFunction(['&:invalid', '&[aria-invalid=true]']),
  _lastChild: createSelectorFunction('&:last-child'),
  _lastOfType: createSelectorFunction('&:last-of-type'),
  _notFirstChild: createSelectorFunction('&:not(:first-child)'),
  _notFirstOfType: createSelectorFunction('&:not(:first-of-type)'),
  _notLastChild: createSelectorFunction('&:not(:last-child)'),
  _notLastOfType: createSelectorFunction('&:not(:last-of-type)'),
  _nthOfType: createNthOfTypeSelectorFunction('&:nth-of-type'),
  _readOnly: createSelectorFunction(['&:read-only', '&[aria-readonly=true]', '&[data-readonly]']),
  _selected: createSelectorFunction(['&[aria-selected=true]', '&[data-selected]']),
  _valid: createSelectorFunction(['&[aria-invalid=false]', '&:valid']),
  _visited: createSelectorFunction('&:visited')
};

/**
 * Pseudo-elements
 * https://developer.mozilla.org/en-US/docs/Web/CSS/
 */
var pseudoElementSelector = {
  __after: createSelectorFunction('&::after'),
  __backdrop: createSelectorFunction('&::backdrop'),
  __before: createSelectorFunction('&::before'),
  __cue: createSelectorFunction('&::cue'),
  __firstLetter: createSelectorFunction('&::first-letter'),
  __firstLine: createSelectorFunction('&::first-line'),
  __placeholder: createSelectorFunction('&::placeholder'),
  __placeholderShown: createSelectorFunction('&::placeholder-shown'),
  __selection: createSelectorFunction('&::selection')
};

// based on https://github.com/developit/dlv
var get = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];
  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }
  return obj === undef ? def : obj;
};

var mergeObject = function mergeObject(a, b) {
  var result = Object.assign({}, a, b);
  for (var key in a) {
    if (!Object.prototype.hasOwnProperty.call(a, key)) {
      continue;
    }
    if (!a[key] || _typeof(b[key]) !== 'object') {
      continue;
    }
    Object.assign(result, _defineProperty({}, key, Object.assign(a[key], b[key])));
  }
  return result;
};

// sort object-value responsive styles
var sortObject = function sortObject(obj) {
  var next = {};
  Object.keys(obj).sort(function (a, b) {
    return a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }).forEach(function (key) {
    next[key] = obj[key];
  });
  return next;
};

var defaultBreakpoints$1 = [];
var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width: ".concat(n, ")");
};
var parser = function parser(config) {
  var cache = {};
  var parse = function parse(props) {
    var styles = {};
    var shouldSort = false;
    var isCacheDisabled = props.theme && props.theme.disableStyledSystemCache;
    for (var key in props) {
      if (!config[key]) {
        continue;
      }
      var sx = config[key];
      var raw = props[key];
      var scale = get(props.theme, sx.scale, sx.defaultScale);
      if (_typeof(raw) === 'object') {
        cache.breakpoints = !isCacheDisabled && cache.breakpoints || get(props.theme, 'breakpoints', defaultBreakpoints$1);
        if (Array.isArray(raw)) {
          cache.media = !isCacheDisabled && cache.media || [null].concat(_toConsumableArray(cache.breakpoints.map(createMediaQuery)));
          styles = mergeObject(styles, parseResponsiveStyle(cache.media, sx, scale, raw, props));
          continue;
        }
        if (raw !== null) {
          styles = mergeObject(styles, parseResponsiveObject(cache.breakpoints, sx, scale, raw, props));
          shouldSort = true;
        }
        continue;
      }
      Object.assign(styles, sx(raw, scale, props));
    }
    if (shouldSort) {
      // sort object-based responsive styles
      styles = sortObject(styles);
    }
    return styles;
  };
  parse.config = config;
  parse.propNames = Object.keys(config);
  parse.cache = cache;
  var keys = Object.keys(config).filter(function (k) {
    return k !== 'config';
  });
  if (keys.length > 1) {
    keys.forEach(function (key) {
      parse[key] = parser(_defineProperty({}, key, config[key]));
    });
  }
  return parse;
};
var parseResponsiveStyle = function parseResponsiveStyle(mediaQueries, sx, scale, raw, _props) {
  var styles = {};
  raw.slice(0, mediaQueries.length).forEach(function (value, i) {
    var media = mediaQueries[i];
    var style = sx(value, scale, _props);
    if (!media) {
      Object.assign(styles, style);
    } else {
      Object.assign(styles, _defineProperty({}, media, Object.assign({}, styles[media], style)));
    }
  });
  return styles;
};
var parseResponsiveObject = function parseResponsiveObject(breakpoints, sx, scale, raw, _props) {
  var styles = {};
  for (var key in raw) {
    if (!Object.prototype.hasOwnProperty.call(raw, key)) {
      continue;
    }
    var breakpoint = breakpoints[key];
    var value = raw[key];
    var style = sx(value, scale, _props);
    if (!breakpoint) {
      Object.assign(styles, style);
    } else {
      var media = createMediaQuery(breakpoint);
      Object.assign(styles, _defineProperty({}, media, Object.assign({}, styles[media], style)));
    }
  }
  return styles;
};

var compose = function compose() {
  var config = {};
  for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers[_key] = arguments[_key];
  }
  parsers.forEach(function (p) {
    if (!p || !p.config) {
      return;
    }
    Object.assign(config, p.config);
  });
  return parser(config);
};

var ensureArray = function ensureArray(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (value === undefined || value === null) {
    return [].concat(defaultValue);
  }
  return Array.isArray(value) ? value : [].concat(value);
};

var getValue = function getValue(n, scale) {
  return get(scale, n, n);
};
var system$1 = function system(config, options) {
  var group = options === null || options === void 0 ? void 0 : options.group;
  var styleConfig = Object.keys(_objectSpread2({}, config)).reduce(function (acc, key) {
    var value = config[key];
    if (typeof value === 'function') {
      acc[key] = value;
      return acc;
    }
    if (value === true) {
      // shortcut definition
      acc[key] = createStyleFunction({
        group: group,
        property: key
      });
      return acc;
    }
    acc[key] = createStyleFunction(_objectSpread2({
      group: group
    }, value));
    return acc;
  }, {});
  return parser(styleConfig);
};
var createStyleFunction = function createStyleFunction(_ref) {
  var group = _ref.group,
    properties = _ref.properties,
    property = _ref.property,
    alias = _ref.alias,
    scale = _ref.scale,
    defaultScale = _ref.defaultScale,
    _ref$transform = _ref.transform,
    transform = _ref$transform === void 0 ? getValue : _ref$transform;
  properties = ensureArray(properties).concat(ensureArray(property));
  var sx = function sx(value, scale, _props) {
    var result = {};
    var n = transform(value, scale, _props);
    if (n !== null && n !== undefined) {
      properties.forEach(function (prop) {
        result[prop] = n;
      });
    }
    return result;
  };
  sx.group = group;
  sx.originalProperties = properties;
  sx.alias = alias;
  sx.scale = scale;
  sx.defaultScale = defaultScale;
  return sx;
};

var group$n = 'animation';
var config$n = {
  animation: true,
  animationDelay: true,
  animationDirection: true,
  animationDuration: true,
  animationFillMode: true,
  animationIterationCount: true,
  animationName: true,
  animationPlayState: true,
  animationTimingFunction: true
};
var animation = system$1(config$n, {
  group: group$n
});

var positiveOrNegative = function positiveOrNegative(value, scale, props) {
  /**
   * Scale object
   *
   * ```js
   * {
   *   '1x': '0.25rem',
   *   '2x': 8,
   * }
   * ```
   *
   * Example
   *
   * ```jsx
   * <Box margin="1x" />
   * // => margin: 0.25rem
   * <Box margin="2x" />
   * // => margin: 8px
   * <Box margin="-1x" />
   * // => margin: -0.25rem
   * <Box margin="-2x" />
   * // => margin: -8px
   * ```
   */
  if (typeof value === 'string') {
    var isNegative = value.startsWith('-');
    if (!isNegative) {
      return get(scale, value, value);
    }
    var absoluteValue = value.startsWith('+') || value.startsWith('-') ? value.slice(1) : value;
    var n = get(scale, absoluteValue, absoluteValue);
    if (typeof n === 'string') {
      return "-".concat(n);
    }
    return n * -1;
  }

  /**
   * Scale object
   *
   * ```js
   * {
   *   4: '0.25rem',
   *   8: 8,
   * }
   * ```
   *
   * Example
   *
   * ```jsx
   * <Box margin={4} />
   * // => margin: 0.25rem
   * <Box margin={8} />
   * // => margin: 8px
   * <Box margin={-4} />
   * // => margin: -0.25rem
   * <Box margin={-8} />
   * // => margin: -8px
   * ```
   */
  if (typeof value === 'number' && Number.isFinite(value)) {
    var _isNegative = value < 0;
    if (!_isNegative) {
      return get(scale, value, value);
    }
    var _absoluteValue = Math.abs(value);
    var _n = get(scale, _absoluteValue, _absoluteValue);
    if (typeof _n === 'string') {
      return "-".concat(_n);
    }
    return _n * -1;
  }
  return get(scale, value, value);
};

var group$m = 'background';
var config$m = {
  background: {
    property: 'background',
    scale: 'colors'
  },
  backgroundAttachment: {
    property: 'backgroundAttachment'
  },
  backgroundClip: {
    property: 'backgroundClip'
  },
  backgroundColor: {
    property: 'backgroundColor',
    scale: 'colors'
  },
  backgroundImage: {
    property: 'backgroundImage'
  },
  backgroundPosition: {
    property: 'backgroundPosition',
    scale: 'space',
    transform: positiveOrNegative // multi-value
  },

  backgroundPositionX: {
    property: 'backgroundPositionX',
    scale: 'space',
    transform: positiveOrNegative
  },
  backgroundPositionY: {
    property: 'backgroundPositionY',
    scale: 'space',
    transform: positiveOrNegative
  },
  backgroundRepeat: {
    property: 'backgroundRepeat'
  },
  backgroundSize: {
    property: 'backgroundSize',
    scale: 'sizes'
  }
};
config$m.bg = _objectSpread2(_objectSpread2({}, config$m.background), {}, {
  alias: 'background'
});
config$m.bgAttachment = _objectSpread2(_objectSpread2({}, config$m.backgroundAttachment), {}, {
  alias: 'backgroundAttachment'
});
config$m.bgClip = _objectSpread2(_objectSpread2({}, config$m.backgroundClip), {}, {
  alias: 'backgroundClip'
});
config$m.bgColor = _objectSpread2(_objectSpread2({}, config$m.backgroundColor), {}, {
  alias: 'backgroundColor'
});
config$m.bgImage = _objectSpread2(_objectSpread2({}, config$m.backgroundImage), {}, {
  alias: 'backgroundImage'
});
config$m.bgPosition = _objectSpread2(_objectSpread2({}, config$m.backgroundPosition), {}, {
  alias: 'backgroundPosition'
});
config$m.bgPositionX = _objectSpread2(_objectSpread2({}, config$m.backgroundPositionX), {}, {
  alias: 'backgroundPositionX'
});
config$m.bgPositionY = _objectSpread2(_objectSpread2({}, config$m.backgroundPositionY), {}, {
  alias: 'backgroundPositionY'
});
config$m.bgRepeat = _objectSpread2(_objectSpread2({}, config$m.backgroundRepeat), {}, {
  alias: 'backgroundRepeat'
});
config$m.bgSize = _objectSpread2(_objectSpread2({}, config$m.backgroundSize), {}, {
  alias: 'backgroundSize'
});
var background = system$1(config$m, {
  group: group$m
});

var _border = {
  /**
   * The border shorthand CSS property sets an element's border.
   * It sets the values of border-width, border-style, and border-color.
   */
  border: {
    property: 'border',
    scale: 'borders'
  },
  borderColor: {
    property: 'borderColor',
    scale: 'colors'
  },
  borderStyle: true,
  borderWidth: {
    property: 'borderWidth',
    scale: 'sizes'
  }
};
var _borderTop = {
  /**
   * The border-top shorthand CSS property sets all the properties of an element's top border.
   * It sets the values of border-top-width, border-top-style and border-top-color.
   */
  borderTop: {
    property: 'borderTop',
    scale: 'borders'
  },
  borderTopColor: {
    property: 'borderTopColor',
    scale: 'colors'
  },
  borderTopStyle: true,
  borderTopWidth: {
    property: 'borderTopWidth',
    scale: 'sizes'
  }
};
var _borderRight = {
  /**
   * The border-right shorthand CSS property sets all the properties of an element's right border.
   * It sets the values of border-right-width, border-right-style and border-right-color.
   */
  borderRight: {
    property: 'borderRight',
    scale: 'borders'
  },
  borderRightColor: {
    property: 'borderRightColor',
    scale: 'colors'
  },
  borderRightStyle: true,
  borderRightWidth: {
    property: 'borderRightWidth',
    scale: 'sizes'
  }
};
var _borderBottom = {
  /**
   * The border-bottom shorthand CSS property sets an element's bottom border.
   * It sets the values of border-bottom-width, border-bottom-style and border-bottom-color.
   */
  borderBottom: {
    property: 'borderBottom',
    scale: 'borders'
  },
  borderBottomColor: {
    property: 'borderBottomColor',
    scale: 'colors'
  },
  borderBottomStyle: true,
  borderBottomWidth: {
    property: 'borderBottomWidth',
    scale: 'sizes'
  }
};
var _borderLeft = {
  /**
   * The border-left shorthand CSS property sets all the properties of an element's left border.
   * It sets the values of border-left-width, border-left-style and border-left-color.
   */
  borderLeft: {
    property: 'borderLeft',
    scale: 'borders'
  },
  borderLeftColor: {
    property: 'borderLeftColor',
    scale: 'colors'
  },
  borderLeftStyle: true,
  borderLeftWidth: {
    property: 'borderLeftWidth',
    scale: 'sizes'
  }
};
var _borderRadius = {
  /**
   * The border-radius shorthand CSS property sets the rounding of an element's corners.
   * It sets the values of border-top-left-radius, border-top-right-radius, border-bottom-right-radius, and border-bottom-left-radius.
   */
  borderRadius: {
    property: 'borderRadius',
    scale: 'radii'
  },
  borderTopLeftRadius: {
    property: 'borderTopLeftRadius',
    scale: 'radii'
  },
  borderTopRightRadius: {
    property: 'borderTopRightRadius',
    scale: 'radii'
  },
  borderBottomLeftRadius: {
    property: 'borderBottomLeftRadius',
    scale: 'radii'
  },
  borderBottomRightRadius: {
    property: 'borderBottomRightRadius',
    scale: 'radii'
  },
  borderEndEndRadius: {
    property: 'borderEndEndRadius',
    scale: 'radii'
  },
  borderEndStartRadius: {
    property: 'borderEndStartRadius',
    scale: 'radii'
  },
  borderStartEndRadius: {
    property: 'borderStartEndRadius',
    scale: 'radii'
  },
  borderStartStartRadius: {
    property: 'borderStartStartRadius',
    scale: 'radii'
  }
};
var _borderBlock = {
  /**
   * The border-block CSS property is a shorthand property for setting the individual logical block border property values in a single place in the style sheet.
   */
  borderBlock: {
    property: 'borderBlock',
    scale: 'borders'
  },
  borderBlockColor: {
    property: 'borderBlockColor',
    scale: 'colors'
  },
  borderBlockStyle: true,
  borderBlockWidth: {
    property: 'borderBlockWidth',
    scale: 'sizes'
  },
  borderBlockEnd: {
    property: 'borderBlockEnd',
    scale: 'borders'
  },
  borderBlockEndColor: {
    property: 'borderBlockEndColor',
    scale: 'colors'
  },
  borderBlockEndStyle: true,
  borderBlockEndWidth: {
    property: 'borderBlockEndWidth',
    scale: 'sizes'
  },
  borderBlockStart: {
    property: 'borderBlockStart',
    scale: 'borders'
  },
  borderBlockStartColor: {
    property: 'borderBlockStartColor',
    scale: 'colors'
  },
  borderBlockStartStyle: true,
  borderBlockStartWidth: {
    property: 'borderBlockStartWidth',
    scale: 'sizes'
  }
};
var _borderImage = {
  /**
   * The border-image shorthand CSS property draws an image around a given element. It replaces the element's regular border.
   */
  borderImage: true,
  borderImageOutset: {
    property: 'borderImageOutset',
    scale: 'space',
    transform: positiveOrNegative // multi-value
  },

  borderImageRepeat: true,
  borderImageSlice: {
    property: 'borderImageSlice',
    scale: 'space',
    transform: positiveOrNegative // multi-value
  },

  borderImageSource: true,
  borderImageWidth: {
    property: 'borderImageWidth',
    scale: 'sizes'
  }
};
var _borderInline = {
  /**
   * The border-inline CSS property is a shorthand property for setting the individual logical inline border property values in a single place in the style sheet.
   */
  borderInline: {
    property: 'borderInline',
    scale: 'borders'
  },
  borderInlineColor: {
    property: 'borderInlineColor',
    scale: 'colors'
  },
  borderInlineStyle: true,
  borderInlineWidth: {
    property: 'borderInlineWidth',
    scale: 'sizes'
  },
  borderInlineEnd: {
    property: 'borderInlineEnd',
    scale: 'borders'
  },
  borderInlineEndColor: {
    property: 'borderInlineEndColor',
    scale: 'colors'
  },
  borderInlineEndStyle: true,
  borderInlineEndWidth: {
    property: 'borderInlineEndWidth',
    scale: 'sizes'
  },
  borderInlineStart: {
    property: 'borderInlineStart',
    scale: 'borders'
  },
  borderInlineStartColor: {
    property: 'borderInlineStartColor',
    scale: 'colors'
  },
  borderInlineStartStyle: true,
  borderInlineStartWidth: {
    property: 'borderInlineStartWidth',
    scale: 'sizes'
  }
};
var group$l = 'border';
var config$l = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, _border), _borderTop), _borderRight), _borderBottom), _borderLeft), _borderRadius), _borderBlock), _borderImage), _borderInline), {}, {
  borderCollapse: true,
  borderSpacing: {
    property: 'borderSpacing',
    scale: 'sizes'
  },
  borderX: {
    properties: ['borderLeft', 'borderRight'],
    scale: 'borders'
  },
  borderY: {
    properties: ['borderTop', 'borderBottom'],
    scale: 'borders'
  }
});
var border = system$1(config$l, {
  group: group$l
});

var group$k = 'color';
var config$k = {
  color: {
    property: 'color',
    scale: 'colors'
  },
  colorScheme: true,
  /**
   * The CSS `fill` property for SVG elements
   */
  fill: {
    property: 'fill',
    scale: 'colors'
  },
  /**
   * The CSS `stroke` property for SVG elements
   */
  stroke: {
    property: 'stroke',
    scale: 'colors'
  }
};
var color = system$1(config$k, {
  group: group$k
});

var group$j = 'containment';
var config$j = {
  contain: true,
  containIntrinsicSize: {
    property: 'containIntrinsicSize',
    scale: 'sizes'
  },
  contentVisibility: true
};
var containment = system$1(config$j, {
  group: group$j
});

var group$i = 'effect';
var config$i = {
  backdropFilter: true,
  backgroundBlendMode: true,
  boxShadow: {
    property: 'boxShadow',
    scale: 'shadows'
  },
  filter: true,
  mixBlendMode: true,
  opacity: true
};
var effect = system$1(config$i, {
  group: group$i
});

var group$h = 'flexbox';
var config$h = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: {
    property: 'flexBasis',
    scale: 'sizes'
  },
  justifySelf: true,
  alignSelf: true,
  order: true
};
var flexbox = system$1(config$h, {
  group: group$h
});

var group$g = 'gap';
var config$g = {
  gap: {
    property: 'gap',
    scale: 'sizes'
  },
  columnGap: {
    property: 'columnGap',
    scale: 'sizes'
  },
  rowGap: {
    property: 'rowGap',
    scale: 'sizes'
  }
};
var gap = system$1(config$g, {
  group: group$g
});

var group$f = 'grid';
var config$f = {
  gridGap: {
    property: 'gridGap',
    scale: 'sizes'
  },
  gridColumnGap: {
    property: 'gridColumnGap',
    scale: 'sizes'
  },
  gridRowGap: {
    property: 'gridRowGap',
    scale: 'sizes'
  },
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridAutoRows: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};
var grid = system$1(config$f, {
  group: group$f
});

var group$e = 'image';
var config$e = {
  imageOrientation: true,
  imageRendering: true
};
var image = system$1(config$e, {
  group: group$e
});

var group$d = 'interactivity';
var config$d = {
  appearance: true,
  caretColor: {
    property: 'caretColor',
    scale: 'colors'
  },
  cursor: true,
  pointerEvents: true,
  resize: true,
  userSelect: true
};
var interactivity = system$1(config$d, {
  group: group$d
});

var group$c = 'layout';
var config$c = {
  width: {
    property: 'width',
    scale: 'sizes'
  },
  height: {
    property: 'height',
    scale: 'sizes'
  },
  minWidth: {
    property: 'minWidth',
    scale: 'sizes'
  },
  minHeight: {
    property: 'minHeight',
    scale: 'sizes'
  },
  maxWidth: {
    property: 'maxWidth',
    scale: 'sizes'
  },
  maxHeight: {
    property: 'maxHeight',
    scale: 'sizes'
  },
  overflow: true,
  overflowX: true,
  overflowY: true,
  display: true,
  verticalAlign: true,
  aspectRatio: true,
  boxSizing: true,
  "float": true,
  objectFit: true,
  objectPosition: true,
  visibility: true
};
config$c.w = _objectSpread2(_objectSpread2({}, config$c.width), {}, {
  alias: 'width'
});
config$c.h = _objectSpread2(_objectSpread2({}, config$c.height), {}, {
  alias: 'height'
});
var layout = system$1(config$c, {
  group: group$c
});

var group$b = 'list-style';
var config$b = {
  listStyleImage: true,
  listStylePosition: true,
  listStyleType: true
};
var listStyle = system$1(config$b, {
  group: group$b
});

var group$a = 'margin';
var config$a = {
  margin: {
    property: 'margin',
    scale: 'space',
    transform: positiveOrNegative // multi-value
  },

  marginTop: {
    property: 'marginTop',
    scale: 'space',
    transform: positiveOrNegative
  },
  marginRight: {
    property: 'marginRight',
    scale: 'space',
    transform: positiveOrNegative
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'space',
    transform: positiveOrNegative
  },
  marginLeft: {
    property: 'marginLeft',
    scale: 'space',
    transform: positiveOrNegative
  },
  marginBlock: {
    property: 'marginBlock',
    scale: 'space',
    transform: positiveOrNegative
  },
  marginBlockStart: {
    property: 'marginBlockStart',
    scale: 'space',
    transform: positiveOrNegative
  },
  marginBlockEnd: {
    property: 'marginBlockEnd',
    scale: 'space',
    transform: positiveOrNegative
  },
  marginInline: {
    property: 'marginInline',
    scale: 'space',
    transform: positiveOrNegative
  },
  marginInlineStart: {
    property: 'marginInlineStart',
    scale: 'space',
    transform: positiveOrNegative
  },
  marginInlineEnd: {
    property: 'marginInlineEnd',
    scale: 'space',
    transform: positiveOrNegative
  }
};
config$a.marginX = {
  properties: ['marginLeft', 'marginRight'],
  scale: 'space',
  transform: positiveOrNegative
};
config$a.marginY = {
  properties: ['marginTop', 'marginBottom'],
  scale: 'space',
  transform: positiveOrNegative
};
config$a.m = _objectSpread2(_objectSpread2({}, config$a.margin), {}, {
  alias: 'margin'
});
config$a.mt = _objectSpread2(_objectSpread2({}, config$a.marginTop), {}, {
  alias: 'marginTop'
});
config$a.mr = _objectSpread2(_objectSpread2({}, config$a.marginRight), {}, {
  alias: 'marginRight'
});
config$a.mb = _objectSpread2(_objectSpread2({}, config$a.marginBottom), {}, {
  alias: 'marginBottom'
});
config$a.ml = _objectSpread2(_objectSpread2({}, config$a.marginLeft), {}, {
  alias: 'marginLeft'
});
config$a.mx = _objectSpread2(_objectSpread2({}, config$a.marginX), {}, {
  alias: 'marginX'
});
config$a.my = _objectSpread2(_objectSpread2({}, config$a.marginY), {}, {
  alias: 'marginY'
});
var margin = system$1(config$a, {
  group: group$a
});

/**
 * https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Masking
 */
var group$9 = 'masking';
var config$9 = {
  clip: true,
  // deprecated: This feature is no longer recommended
  clipPath: true,
  mask: true,
  maskBorder: true,
  maskType: true,
  // The mask property is a shorthand for the following CSS properties:
  maskClip: true,
  maskComposite: true,
  maskImage: true,
  maskMode: true,
  maskOrigin: true,
  maskPosition: true,
  maskRepeat: true,
  maskSize: true,
  // The `mask-border` property is a shorthand for the following CSS properties:
  maskBorderMode: true,
  maskBorderOutset: true,
  maskBorderRepeat: true,
  maskBorderSlice: true,
  maskBorderSource: true,
  maskBorderWidth: true
};
var masking = system$1(config$9, {
  group: group$9
});

var group$8 = 'outline';
var config$8 = {
  outline: {
    property: 'outline',
    scale: 'outlines'
  },
  outlineColor: {
    property: 'outlineColor',
    scale: 'colors'
  },
  outlineOffset: {
    property: 'outlineOffset',
    scale: 'space',
    transform: positiveOrNegative
  },
  outlineWidth: {
    property: 'outlineWidth',
    scale: 'sizes'
  },
  outlineStyle: true
};
var outline = system$1(config$8, {
  group: group$8
});

var group$7 = 'padding';
var config$7 = {
  padding: {
    property: 'padding',
    scale: 'space'
  },
  paddingTop: {
    property: 'paddingTop',
    scale: 'space'
  },
  paddingRight: {
    property: 'paddingRight',
    scale: 'space'
  },
  paddingBottom: {
    property: 'paddingBottom',
    scale: 'space'
  },
  paddingLeft: {
    property: 'paddingLeft',
    scale: 'space'
  }
};
config$7.paddingX = {
  properties: ['paddingLeft', 'paddingRight'],
  scale: 'space'
};
config$7.paddingY = {
  properties: ['paddingTop', 'paddingBottom'],
  scale: 'space'
};
config$7.p = _objectSpread2(_objectSpread2({}, config$7.padding), {}, {
  alias: 'padding'
});
config$7.pt = _objectSpread2(_objectSpread2({}, config$7.paddingTop), {}, {
  alias: 'paddingTop'
});
config$7.pr = _objectSpread2(_objectSpread2({}, config$7.paddingRight), {}, {
  alias: 'paddingRight'
});
config$7.pb = _objectSpread2(_objectSpread2({}, config$7.paddingBottom), {}, {
  alias: 'paddingBottom'
});
config$7.pl = _objectSpread2(_objectSpread2({}, config$7.paddingLeft), {}, {
  alias: 'paddingLeft'
});
config$7.px = _objectSpread2(_objectSpread2({}, config$7.paddingX), {}, {
  alias: 'paddingX'
});
config$7.py = _objectSpread2(_objectSpread2({}, config$7.paddingY), {}, {
  alias: 'paddingY'
});
var padding = system$1(config$7, {
  group: group$7
});

var group$6 = 'position';
var config$6 = {
  inset: {
    property: 'inset',
    scale: 'space',
    transform: positiveOrNegative // multi-value
  },

  insetBlock: {
    property: 'insetBlock',
    scale: 'space',
    transform: positiveOrNegative // multi-value
  },

  insetBlockEnd: {
    property: 'insetBlockEnd',
    scale: 'space',
    transform: positiveOrNegative
  },
  insetBlockStart: {
    property: 'insetBlockStart',
    scale: 'space',
    transform: positiveOrNegative
  },
  insetInline: {
    property: 'insetInline',
    scale: 'space',
    transform: positiveOrNegative // multi-value
  },

  insetInlineEnd: {
    property: 'insetInlineEnd',
    scale: 'space',
    transform: positiveOrNegative
  },
  insetInlineStart: {
    property: 'insetInlineStart',
    scale: 'space',
    transform: positiveOrNegative
  },
  position: true,
  top: {
    property: 'top',
    scale: 'space',
    transform: positiveOrNegative
  },
  right: {
    property: 'right',
    scale: 'space',
    transform: positiveOrNegative
  },
  bottom: {
    property: 'bottom',
    scale: 'space',
    transform: positiveOrNegative
  },
  left: {
    property: 'left',
    scale: 'space',
    transform: positiveOrNegative
  },
  zIndex: {
    property: 'zIndex',
    scale: 'zIndices'
  }
};
var position = system$1(config$6, {
  group: group$6
});

var group$5 = 'scroll';
var config$5 = {
  scrollBehavior: true,
  scrollMargin: {
    property: 'scrollMargin',
    scale: 'space',
    transform: positiveOrNegative // multi-value
  },

  scrollMarginBlock: {
    property: 'scrollMarginBlock',
    scale: 'space',
    transform: positiveOrNegative // multi-value
  },

  scrollMarginBlockEnd: {
    property: 'scrollMarginBlockEnd',
    scale: 'space',
    transform: positiveOrNegative
  },
  scrollMarginBlockStart: {
    property: 'scrollMarginBlockStart',
    scale: 'space',
    transform: positiveOrNegative
  },
  scrollMarginInline: {
    property: 'scrollMarginInline',
    scale: 'space',
    transform: positiveOrNegative // multi-value
  },

  scrollMarginInlineEnd: {
    property: 'scrollMarginInlineEnd',
    scale: 'space',
    transform: positiveOrNegative
  },
  scrollMarginInlineStart: {
    property: 'scrollMarginInlineStart',
    scale: 'space',
    transform: positiveOrNegative
  },
  scrollMarginTop: {
    property: 'scrollMarginTop',
    scale: 'space',
    transform: positiveOrNegative
  },
  scrollMarginRight: {
    property: 'scrollMarginRight',
    scale: 'space',
    transform: positiveOrNegative
  },
  scrollMarginBottom: {
    property: 'scrollMarginBottom',
    scale: 'space',
    transform: positiveOrNegative
  },
  scrollMarginLeft: {
    property: 'scrollMarginLeft',
    scale: 'space',
    transform: positiveOrNegative
  },
  scrollPadding: {
    property: 'scrollPadding',
    scale: 'space'
  },
  scrollPaddingTop: {
    property: 'scrollPaddingTop',
    scale: 'space'
  },
  scrollPaddingRight: {
    property: 'scrollPaddingRight',
    scale: 'space'
  },
  scrollPaddingBottom: {
    property: 'scrollPaddingBottom',
    scale: 'space'
  },
  scrollPaddingLeft: {
    property: 'scrollPaddingLeft',
    scale: 'space'
  },
  scrollSnapAlign: true,
  scrollSnapStop: true,
  scrollSnapType: true
};
config$5.scrollMarginX = {
  properties: ['scrollMarginLeft', 'scrollMarginRight'],
  scale: 'space',
  transform: positiveOrNegative
};
config$5.scrollMarginY = {
  properties: ['scrollMarginTop', 'scrollMarginBottom'],
  scale: 'space',
  transform: positiveOrNegative
};
config$5.scrollPaddingX = {
  properties: ['scrollPaddingLeft', 'scrollPaddingRight'],
  scale: 'space'
};
config$5.scrollPaddingY = {
  properties: ['scrollPaddingTop', 'scrollPaddingBottom'],
  scale: 'space'
};
var scroll = system$1(config$5, {
  group: group$5
});

/**
 * https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Shapes
 */
var group$4 = 'shape';
var config$4 = {
  shapeImageThreshold: true,
  shapeMargin: {
    property: 'shapeMargin',
    scale: 'space',
    transform: positiveOrNegative // multi-value
  },

  shapeOutside: true
};
var shape = system$1(config$4, {
  group: group$4
});

var group$3 = 'text';
var config$3 = {
  textCombineUpright: true,
  textDecoration: true,
  textDecorationColor: {
    property: 'textDecorationColor',
    scale: 'colors'
  },
  textDecorationLine: true,
  textDecorationStyle: true,
  textDecorationThickness: {
    property: 'textDecorationThickness',
    scale: 'sizes'
  },
  textOrientation: true,
  textShadow: {
    property: 'textShadow',
    scale: 'shadows'
  },
  textUnderlineOffset: {
    property: 'textUnderlineOffset',
    scale: 'space',
    transform: positiveOrNegative
  },
  writingMode: true
};
var textDecoration = system$1(config$3, {
  group: group$3
});

var group$2 = 'transform';
var config$2 = {
  backfaceVisibility: true,
  perspective: true,
  perspectiveOrigin: true,
  transform: true,
  transformBox: true,
  transformOrigin: true,
  transformStyle: true
};
var transform = system$1(config$2, {
  group: group$2
});

var group$1 = 'transition';
var config$1 = {
  transition: true,
  transitionDelay: true,
  transitionDuration: true,
  transitionProperty: true,
  transitionTimingFunction: true,
  willChange: true
};
var transition = system$1(config$1, {
  group: group$1
});

var group = 'typography';
var config = {
  fontFamily: {
    property: 'fontFamily',
    scale: 'fonts'
  },
  fontSize: {
    property: 'fontSize',
    scale: 'fontSizes'
  },
  fontStyle: true,
  fontWeight: {
    property: 'fontWeight',
    scale: 'fontWeights'
  },
  letterSpacing: {
    property: 'letterSpacing',
    scale: 'letterSpacings'
  },
  lineBreak: true,
  lineHeight: {
    property: 'lineHeight',
    scale: 'lineHeights'
  },
  overflowWrap: true,
  textAlign: true,
  textEmphasis: true,
  textIndent: true,
  textJustify: true,
  textOverflow: true,
  textTransform: true,
  whiteSpace: true,
  wordBreak: true,
  wordSpacing: true
};
var typography = system$1(config, {
  group: group
});

var system = compose(animation, background, border, color, containment, effect, flexbox, gap, grid, image, interactivity, layout, listStyle, margin, masking, outline, padding, position, scroll, shape, textDecoration, transform, transition, typography);

var defaultBreakpoints = [];
var responsive = function responsive(styles) {
  return function (theme) {
    var next = {};
    var breakpoints = ensureArray(get(theme, 'breakpoints', defaultBreakpoints));
    var mediaQueries = [null].concat(_toConsumableArray(breakpoints.map(function (n) {
      return "@media screen and (min-width: ".concat(n, ")");
    })));
    for (var key in styles) {
      if (!Object.prototype.hasOwnProperty.call(styles, key)) {
        continue;
      }
      var value = typeof styles[key] === 'function' ? styles[key](theme) : styles[key];
      if (value == null) {
        continue;
      }
      if (!Array.isArray(value)) {
        next[key] = value;
        continue;
      }
      for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
        var media = mediaQueries[i];
        if (!media) {
          next[key] = value[i];
          continue;
        }
        next[media] = next[media] || {};
        if (value[i] == null) {
          continue;
        }
        next[media][key] = value[i];
      }
    }
    return next;
  };
};
var sx = function sx(args) {
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = _objectSpread2({}, props.theme || props);
    var result = {};
    var obj = typeof args === 'function' ? args(theme) : args;
    var styles = responsive(obj)(theme);
    for (var key in styles) {
      if (!Object.prototype.hasOwnProperty.call(styles, key)) {
        continue;
      }
      var x = styles[key];
      var val = typeof x === 'function' ? x(theme) : x;
      if (val && _typeof(val) === 'object') {
        result[key] = sx(val)(theme);
        continue;
      }
      var _sx = system.config[key];
      if (typeof _sx !== 'function') {
        // pass them through to the result for unknown props
        result[key] = val;
        continue;
      }
      var _scale = get(theme, _sx.scale, _sx.defaultScale);
      var _props = _objectSpread2(_objectSpread2({}, styles), {}, {
        theme: theme // include "theme" in props
      });

      var _result = _sx(val, _scale, _props); // `sx` is a style function

      result = _objectSpread2(_objectSpread2({}, result), _result);
    }
    return result;
  };
};

export { pseudoClassSelector, pseudoElementSelector, sx, system };
